'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.intercomUpdate = exports.intercomOnMessage = exports.intercomShowMessenger = exports.intercomTrackEvent = exports.intercomShutdown = exports.intercomBoot = exports.intercomAPI = exports.intercomAvaliable = undefined;

var _lodash = require('lodash');

var _getClientConfig = require('../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _logger = require('../../client/utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _analyticsConstants = require('./analyticsConstants');

var _timeUtil = require('../../common/utils/timeUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useIntercom = (0, _lodash.memoize)(function () {
    return (0, _getClientConfig2.default)().analytics.enabled;
});
var intercomAvaliable = exports.intercomAvaliable = (0, _lodash.memoize)(function () {
    return window.document && typeof window.Intercom !== 'undefined';
});

var intercomAPI = exports.intercomAPI = function intercomAPI(action) {
    return function (data, metadata) {
        _logger2.default.info('Analytics:', action, data, metadata);

        if (!useIntercom()) return;
        if (!intercomAvaliable()) return _logger2.default.warn('Intercom not initialized yet');
        window.Intercom(action, data, metadata); // eslint-disable-line new-cap
    };
};

var intercomBoot = exports.intercomBoot = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.boot);
var intercomShutdown = exports.intercomShutdown = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.shutdown);
var intercomTrackEvent = exports.intercomTrackEvent = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.trackEvent);
var intercomShowMessenger = exports.intercomShowMessenger = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.show);
var intercomOnMessage = exports.intercomOnMessage = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.onUnreadCountChange);

// Throttle intercom updates so we don't get throttled by them.
// Prod is on an Intercom SPA beta program with a much higher rate limit
var intercomUpdateAction = intercomAPI(_analyticsConstants.INTERCOM_OPERATIONS.update);
var intercomUpdate = exports.intercomUpdate = (0, _lodash.debounce)(intercomUpdateAction, _timeUtil.TIMES.SECOND * (0, _getClientConfig2.default)().analytics.debounceTimeSeconds, { maxWait: _timeUtil.TIMES.SECOND * (0, _getClientConfig2.default)().analytics.debounceMaxWaitSeconds });


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/intercomService.js
// module id = 290
// module chunks = 0